import { Injectable } from '@angular/core';
import { Vehicle, CreateVehicleDTO } from '../vehicle';
import { environment } from './../../../../environments/environment';
import { AxiosService } from './../../../core/axios';
import { ResponseCodeDTO } from 'src/app/shared/dto/response-codes.dto';

@Injectable({
  providedIn: 'root',
})
export class VehicleModelService {
  private readonly api = environment.apiUrl;

  constructor(private readonly axios: AxiosService) {
    // do nothing
  }

  async getVehicleModels(): Promise<Vehicle[]> {
    const result: ResponseCodeDTO = await this.axios.get(`${this.api}vehicle/my-vehicles`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  createVehicleModel(data: CreateVehicleDTO): Promise<Vehicle> {
    // console.log(data);
    return this.axios.post(`${this.api}vehicle/register`, data);
  }

  updateVehicleModel(id: string, data: CreateVehicleDTO): Promise<Vehicle> {
    return this.axios.patch<Vehicle>(`${this.api}vehicle/update/${id}`, data);
  }

  inactivateVehicleModel(id: string): Promise<any> {
    return this.axios.patch<any>(`${this.api}vehicle/inactivate/${id}`, {});
  }

  updateStatus(id: string, status: boolean): Promise<Vehicle> {
    return this.axios.patch<Vehicle>(`${this.api}vehicle-module/status/${id}`, { status });
  }
  async getOdsHistory(plate: string): Promise<any[]> {
    const result: ResponseCodeDTO = await this.axios.get(`/vehicle/ods-history-tlp?plate=${plate}`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  updateVehicleDetails(
    id: string,
    data: {
      soatExpirationDate: string;
      technicalReviewExpirationDate: string;
      soatEvidenceBase64: string;
      technicalReviewEvidenceBase64: string;
      nextOilChangeKm: number;
    },
  ): Promise<any> {
    return this.axios.patch<any>(`${this.api}vehicle/update-details/${id}`, data);
  }
}
